/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step1_RuleInputs */

const en_dr_step1_rule = /** @type {(inputs: Dr_Step1_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner-authored, three sentences max`)
};

const id_dr_step1_rule = /** @type {(inputs: Dr_Step1_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wajib diisi pemilik ruang, maksimal tiga kalimat`)
};

/**
* | output |
* | --- |
* | "Owner-authored, three sentences max" |
*
* @param {Dr_Step1_RuleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step1_rule = /** @type {((inputs?: Dr_Step1_RuleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step1_RuleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step1_rule(inputs)
	return en_dr_step1_rule(inputs)
});